import { isDocx, isPdf } from '../fileHelpers';
import { isUploadedDocument } from '../isUploadedDocument';
export const isPdfDocument = (document) => {
    const { files = [] } = document || {};
    const isUploaded = isUploadedDocument(document);
    const docxFile = files.find(isDocx);
    const pdfFile = files.find(isPdf);
    return isUploaded && !docxFile && Boolean(pdfFile);
};
